import { Box, Typography } from "@mui/material";
import { Translation } from "src/app/i18n";
import { useStyles } from "./empty.style";
import { InboxOutlined } from "@mui/icons-material";

const Empty = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.loadingContainer}>
      <InboxOutlined sx={{
        fontSize: 40,
        color: 'text.disabled',
      }} />
      <Typography className={classes.loadingText}>
        {Translation("recruitment.exam.registration.empty")}
      </Typography>
    </Box>
  )
}

export default Empty;